// Simple bilingual dictionary — FR default, EN available via toggle.
export const dict = {
  fr: {
    app_name: "Sereno",
    app_tagline: "Épargner et investir, tout simplement.",
    // Landing
    hero_title: "Apprenez à gérer votre argent et à épargner à votre rythme.",
    hero_subtitle:
      "Avancez étape par étape pour comprendre votre budget, mettre de côté selon vos moyens et apprendre à choisir une épargne adaptée à vos projets. Des explications simples, sans jargon, même si vous débutez. Gratuit, sans obligation de souscrire une offre bancaire.",
    start_now: "Commencer",
    already_account: "J'ai déjà un compte",
    feature_1_title: "Une étape à la fois",
    feature_1_desc: "Pas de jargon. Pas de piège. Juste des questions simples.",
    feature_2_title: "Vous voyez grandir vos économies",
    feature_2_desc: "Un calcul clair sur 5, 8 ou 10 ans.",
    feature_3_title: "Une seule recommandation adaptée",
    feature_3_desc: "Choisie pour votre situation, avec un exemple concret.",
    // Auth
    login: "Se connecter",
    register: "Créer mon compte",
    email: "Adresse email",
    password: "Mot de passe",
    name: "Prénom",
    country: "Pays",
    language: "Langue",
    signup_cta: "Créer mon compte",
    login_cta: "Se connecter",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    logout: "Se déconnecter",
    // Tutorial
    step_of: "Étape",
    of: "sur",
    next: "Continuer",
    back: "Retour",
    finish: "Terminer",
    step1_title: "Parlons de votre budget",
    step1_intro:
      "Pas d'inquiétude, personne ne verra ces chiffres. Ils servent juste à savoir combien vous pouvez mettre de côté, sans vous mettre en difficulté.",
    monthly_income: "Combien gagnez-vous chaque mois (après impôts) ?",
    monthly_expenses: "Combien dépensez-vous chaque mois environ ?",
    calc_savings: "Ce qu'il vous reste chaque mois",
    step2_title: "Combien voulez-vous mettre de côté ?",
    step2_intro:
      "Commencez petit. Même 20€ par mois font une vraie différence sur 10 ans.",
    monthly_savings: "Je peux mettre de côté chaque mois",
    initial_amount: "J'ai déjà cette somme de côté (optionnel)",
    step3_title: "Regardez votre argent grandir",
    step3_intro:
      "Voici combien votre épargne pourrait devenir, selon la durée. Ce sont des estimations basées sur des rendements historiques prudents.",
    in_5_years: "Dans 5 ans",
    in_8_years: "Dans 8 ans",
    in_10_years: "Dans 10 ans",
    step4_title: "Quel type d'épargnant êtes-vous ?",
    step4_intro:
      "Aucune mauvaise réponse. Cela nous aide à vous proposer la meilleure option pour vous.",
    risk_prudent: "Prudent",
    risk_prudent_desc: "Je préfère la sécurité, même si ça rapporte moins.",
    risk_equilibre: "Équilibré",
    risk_equilibre_desc: "J'accepte un peu de risque pour gagner un peu plus.",
    risk_dynamique: "Dynamique",
    risk_dynamique_desc:
      "Je peux laisser mon argent longtemps et accepter des variations.",
    step5_title: "Voici l'option qui vous correspond",
    save_reco: "Enregistrer cette recommandation",
    view_dashboard: "Voir mon tableau de bord",
    // Dashboard
    dashboard: "Mon tableau de bord",
    my_profile: "Mon profil",
    my_recos: "Mes recommandations enregistrées",
    no_recos: "Vous n'avez encore rien enregistré.",
    redo_tutorial: "Refaire le tutoriel",
    delete: "Supprimer",
    // Glossary
    glossary: "Glossaire",
    glossary_intro: "Les mots de l'épargne, expliqués simplement.",
    // Currency
    per_month: "/mois",
    years: "ans",
    projected: "Estimation",
    why_this: "Pourquoi cette option ?",
    concrete_example: "Un exemple concret",
    // Errors
    err_generic: "Une erreur est survenue. Veuillez réessayer.",
    required: "Champ obligatoire",
    // New features
    try_guest: "Essayer sans créer de compte",
    try_simulator: "Simuler mon épargne en 1 min",
    guest_banner: "Vous êtes en mode découverte — créez un compte à la fin pour tout sauvegarder.",
    signup_to_save: "Créer un compte pour sauvegarder",
    listen: "Écouter",
    stop: "Arrêter",
    print_pdf: "Imprimer / PDF",
    forgot_password: "Mot de passe oublié ?",
    forgot_title: "Réinitialiser votre mot de passe",
    forgot_intro:
      "Entrez votre email. Si un compte existe, vous recevrez un lien pour choisir un nouveau mot de passe.",
    forgot_sent:
      "Si un compte existe pour cet email, un lien de réinitialisation a été envoyé.",
    send_link: "Envoyer le lien",
    reset_title: "Choisir un nouveau mot de passe",
    new_password: "Nouveau mot de passe",
    reset_cta: "Enregistrer le nouveau mot de passe",
    reset_ok: "Mot de passe modifié ! Vous pouvez vous connecter.",
    monthly_reminder: "Rappel mensuel",
    monthly_reminder_desc:
      "Recevoir un petit rappel dans votre navigateur pour épargner chaque mois.",
    enable_reminder: "Activer les rappels",
    disable_reminder: "Désactiver",
    reminder_enabled: "Rappels activés",
    reminder_permission_denied:
      "Votre navigateur bloque les notifications. Autorisez-les dans les réglages.",
    // Voice
    voice_settings: "Voix",
    voice_choose: "Choisir la voix",
    voice_speed: "Vitesse",
    voice_slow: "Lente",
    voice_normal: "Normale",
    voice_fast: "Rapide",
    voice_default: "Voix par défaut",
    voice_test: "Tester la voix",
    voice_none_available:
      "Aucune voix installée dans votre navigateur pour cette langue.",
    voice_star_hint:
      "⭐ = voix recommandées, les plus naturelles à écouter.",
    // Badges
    badges: "Vos badges",
    checkin_title: "J'ai épargné ce mois-ci",
    checkin_desc:
      "Cliquez ici quand vous avez mis vos économies de côté ce mois-ci. Vous gagnerez un badge à chaque étape !",
    checkin_btn: "Valider ce mois",
    checkin_done: "Bravo ! Vous avez validé ce mois.",
    checkin_this_month: "Mois en cours",
    badge_first_month: "Premier mois",
    badge_first_month_desc: "Votre tout premier mois d'épargne validé. Bravo !",
    badge_three_months: "Trois mois",
    badge_three_months_desc: "Trois mois d'épargne accomplis. Vous prenez le rythme !",
    badge_six_months: "Six mois",
    badge_six_months_desc: "Six mois. Vous devenez un vrai épargnant régulier.",
    badge_one_year: "Un an complet",
    badge_one_year_desc: "Une année complète d'épargne. Incroyable !",
    badge_streak_3: "3 mois d'affilée",
    badge_streak_3_desc: "Trois mois consécutifs sans jamais oublier. Chapeau !",
    badge_temporal_1_month: "Un mois sur Sereno",
    badge_temporal_1_month_desc: "Cela fait un mois que vous avez rejoint Sereno.",
    badge_temporal_6_months: "6 mois sur Sereno",
    badge_temporal_6_months_desc: "6 mois de fidélité à Sereno.",
    badge_temporal_1_year: "1 an sur Sereno",
    badge_temporal_1_year_desc: "Un an sur Sereno, quel beau parcours !",
    badge_tutorial_done: "Tutoriel terminé",
    badge_tutorial_done_desc: "Vous avez terminé le parcours complet. Bien joué !",
    badge_expert_en_herbe: "Expert en herbe",
    badge_expert_en_herbe_desc: "Vous avez réussi le quiz financier. Vous en savez maintenant plus que 80 % des gens !",
    badge_locked: "Badge à débloquer",
    badge_unlocked: "Nouveau badge débloqué !",
    // Share
    share_family: "Envoyer à un proche",
    share_title: "Partager cette recommandation",
    share_intro:
      "Partagez ce plan avec quelqu'un de confiance : un enfant, un ami, un conseiller.",
    share_email_tab: "Par email",
    share_whatsapp_tab: "Par WhatsApp",
    share_link_tab: "Lien à copier",
    share_recipient_email: "Email du destinataire",
    share_message_label: "Petit message (optionnel)",
    share_message_placeholder:
      "Coucou, j'utilise Sereno pour commencer à épargner. Voici la recommandation. Qu'en penses-tu ?",
    share_send_email: "Envoyer par email",
    share_open_whatsapp: "Ouvrir WhatsApp",
    share_copy_link: "Copier le lien",
    share_link_copied: "Lien copié !",
    share_email_sent: "Email envoyé !",
    share_link_valid: "Lien valable 30 jours",
    // Shared public view
    shared_from: "Partagé par",
    shared_wants_to_share: "veut partager avec vous",
    shared_join: "Commencer moi aussi sur Sereno",
    shared_expired: "Ce partage a expiré ou n'existe pas.",
    // Open account block
    open_title: "Comment l'ouvrir concrètement ?",
    open_where: "Où l'ouvrir",
    open_docs: "Ce qu'il faut préparer",
    open_min: "Montant minimum",
    open_time: "Combien de temps",
    open_phrase: "Phrase à dire au conseiller",
    open_online: "En ligne",
    open_branch: "En agence",
    open_call: "Appeler",
    open_visit: "Voir le site",
    open_reassurance: "Ce qu'il faut savoir",
    open_guided_available: "Guide pas à pas disponible",
    open_start_guided: "M'accompagner pas à pas",
    // Guided flow
    guided_step: "Étape",
    guided_of: "sur",
    guided_next: "Continuer",
    guided_back: "Retour",
    guided_finish: "J'ai terminé",
    guided_close: "Fermer",
    guided_pause: "Faire une pause",
    guided_help: "Je suis perdu(e), aidez-moi",
    guided_tips: "Astuces",
    guided_warning: "À ne pas oublier",
    guided_help_call: "Appeler la banque",
    guided_help_share: "Envoyer à un proche",
    guided_help_pause: "Reprendre plus tard",
    // Scam shield (Pilier 5)
    shield: "Bouclier anti-arnaque",
    shield_title: "Vérifions ensemble avant d'envoyer votre argent",
    shield_intro:
      "Copiez-collez le nom de la plateforme, la publicité que vous avez vue, ou tout ce qu'on vous a promis. Sereno analyse les mots d'alerte, sans jugement.",
    shield_placeholder:
      "Ex : « J'ai un robot de trading qui garantit 15 % par mois sur crypto, place limitée. »",
    shield_check_btn: "Analyser",
    shield_analyzing: "Analyse en cours…",
    shield_verdict_danger: "Signaux d'arnaque très forts",
    shield_verdict_caution: "Signaux d'alerte à examiner",
    shield_verdict_trusted: "Acteur reconnu",
    shield_verdict_unknown: "Pas de signal évident, restez prudent(e)",
    shield_flags_title: "Ce que Sereno a repéré",
    shield_reflex_title: "Le réflexe 24h",
    shield_reflex_text:
      "Avant d'envoyer un centime, attendez 24 heures. Aucune vraie opportunité ne disparaît en 24 h — seules les arnaques ont besoin que vous décidiez vite.",
    shield_action_stop: "Arrêtez tout, ne payez rien.",
    shield_action_verify: "Demandez confirmation à un régulateur officiel (AMF, ACPR, FSMA, FINMA, SADC).",
    shield_action_share: "Envoyez ceci à un proche de confiance avant de décider.",
    // AI companion
    ask_sereno: "Poser une question à Sereno",
    ask_sereno_short: "Sereno t'écoute",
    ask_sereno_placeholder: "Écrivez votre question ici, en langage simple…",
    ask_sereno_intro:
      "Posez n'importe quelle question sur l'argent, l'épargne ou une offre qu'on vous propose. Sereno vous répond simplement, sans jugement, à toute heure.",
    ask_send: "Envoyer",
    ask_clear: "Effacer la conversation",
    ask_thinking: "Sereno réfléchit…",
    ask_disclaimer:
      "Sereno vous explique et vous éduque, il ne remplace pas un conseiller financier agréé. Il ne recommande jamais un produit précis.",
    // Transparency
    transparency_title: "En toute transparence",
    transparency_text:
      "Sereno n'a AUCUN lien commercial avec les établissements listés ci-dessous. Ni partenariat, ni commission, ni affiliation. Nous les mentionnons parce qu'ils proposent ce type de produit. Comparez toujours avant de choisir, et n'hésitez pas à consulter votre banque actuelle.",
    compare_title: "Comparez avant de choisir",
    compare_intro:
      "Ne prenez jamais la première option. Regardez au moins 2 fournisseurs et posez-vous ces 4 questions :",
    compare_q1: "Quels sont les frais d'entrée, de gestion, de sortie ?",
    compare_q2: "L'interface est-elle claire pour vous ?",
    compare_q3: "Y a-t-il un vrai conseiller à qui parler par téléphone ?",
    compare_q4: "Que dit Google si vous tapez « avis [nom de la banque] arnaque » ?",
    local_bank_title: "Et votre banque du quartier ?",
    local_bank_text:
      "N'oubliez pas : votre propre banque propose sûrement le même produit. Les frais peuvent être un peu plus élevés, mais vous avez un conseiller humain, en face à face, qui vous connaît. Pour beaucoup, ça vaut la différence de prix.",
    local_bank_cta: "Guide : ouvrir dans votre banque de quartier",
    // Voice mode
    mic_start: "Parler",
    mic_stop: "Arrêter",
    mic_listening: "Sereno vous écoute…",
    mic_not_supported:
      "La reconnaissance vocale n'est pas disponible sur ce navigateur. Essayez Chrome ou Safari.",
    voice_reply_on: "Réponse vocale : activée",
    voice_reply_off: "Réponse vocale : coupée",
    voice_reply_toggle: "Réponse vocale",
    // Photo decoder
    decoder: "Décodeur photo",
    simulator: "Simulateur",
    quiz: "Quiz",
    coach_send_tip: "Recevoir une astuce par email",
    coach_tip_sent: "Astuce envoyée par email — regardez votre boîte !",
    coach_tip_failed: "L'envoi a échoué, réessayez dans un instant.",
    legal_notice: "Mentions légales",
    privacy: "Confidentialité",
    terms: "CGU",
    contact: "Contact",
    footer_disclaimer:
      "Sereno est un outil pédagogique. Les simulations et recommandations affichées ne constituent pas un conseil en investissement. Vous restez seule décisionnaire. Consultez un professionnel agréé avant tout placement important.",
    affiliate_notice:
      "Transparence : certains liens vers des banques partenaires sont des liens affiliés. Si vous ouvrez un compte via ces liens, Sereno peut recevoir une petite commission — sans surcoût pour vous. Nous ne recommandons que des partenaires que nous jugeons sérieux, sur des critères de frais, de sérieux et de fiabilité.",
    decoder_title: "Un papier que vous ne comprenez pas ?",
    decoder_intro:
      "Prenez-le en photo. Sereno le lit et vous explique en 3 phrases, en soulignant les frais cachés ou les pièges éventuels.",
    decoder_choose: "Choisir une photo",
    decoder_take: "Prendre une photo",
    decoder_analyzing: "Sereno lit votre document…",
    decoder_result: "Ce que Sereno a compris",
    decoder_new: "Analyser un autre document",
    decoder_privacy:
      "Votre photo sert uniquement à l'analyse. Elle n'est pas conservée sur nos serveurs.",
    decoder_tip_lighting: "Astuce : photo bien éclairée, sans reflet, texte net.",
  },
  en: {
    app_name: "Sereno",
    app_tagline: "Save and invest, made simple.",
    hero_title: "Learn to manage your money and save at your own pace.",
    hero_subtitle:
      "Move forward step by step to understand your budget, set aside what you can afford, and learn to choose savings that fit your projects. Simple, jargon-free explanations, even if you're a beginner. Free, with no obligation to subscribe to any bank offer.",
    start_now: "Get started",
    already_account: "I already have an account",
    feature_1_title: "One step at a time",
    feature_1_desc: "No jargon. No tricks. Just simple questions.",
    feature_2_title: "See your savings grow",
    feature_2_desc: "A clear projection over 5, 8 or 10 years.",
    feature_3_title: "One tailored recommendation",
    feature_3_desc: "Chosen for your situation, with a concrete example.",
    login: "Log in",
    register: "Create my account",
    email: "Email address",
    password: "Password",
    name: "First name",
    country: "Country",
    language: "Language",
    signup_cta: "Create my account",
    login_cta: "Log in",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    logout: "Log out",
    step_of: "Step",
    of: "of",
    next: "Continue",
    back: "Back",
    finish: "Finish",
    step1_title: "Let's talk about your budget",
    step1_intro:
      "Don't worry, no one sees these numbers. They just help us know how much you can set aside comfortably.",
    monthly_income: "How much do you earn each month (after taxes)?",
    monthly_expenses: "How much do you spend each month roughly?",
    calc_savings: "What's left each month",
    step2_title: "How much would you like to set aside?",
    step2_intro: "Start small. Even €20 a month makes a real difference over 10 years.",
    monthly_savings: "I can set aside each month",
    initial_amount: "I already have this amount saved (optional)",
    step3_title: "Watch your money grow",
    step3_intro:
      "Here's how much your savings could become over time. These are estimates based on conservative historical returns.",
    in_5_years: "In 5 years",
    in_8_years: "In 8 years",
    in_10_years: "In 10 years",
    step4_title: "What kind of saver are you?",
    step4_intro:
      "There's no wrong answer. It helps us suggest the best option for you.",
    risk_prudent: "Cautious",
    risk_prudent_desc: "I prefer safety, even if it earns less.",
    risk_equilibre: "Balanced",
    risk_equilibre_desc: "I accept a little risk to earn a little more.",
    risk_dynamique: "Growth-oriented",
    risk_dynamique_desc:
      "I can leave my money for a long time and accept ups and downs.",
    step5_title: "Here's the option that fits you",
    save_reco: "Save this recommendation",
    view_dashboard: "Go to my dashboard",
    dashboard: "My dashboard",
    my_profile: "My profile",
    my_recos: "My saved recommendations",
    no_recos: "You haven't saved anything yet.",
    redo_tutorial: "Restart the tutorial",
    delete: "Delete",
    glossary: "Glossary",
    glossary_intro: "Saving words, explained simply.",
    per_month: "/mo",
    years: "yrs",
    projected: "Estimate",
    why_this: "Why this option?",
    concrete_example: "A concrete example",
    err_generic: "Something went wrong. Please try again.",
    required: "Required field",
    try_guest: "Try without creating an account",
    try_simulator: "Simulate my savings in 1 min",
    guest_banner:
      "You're in discovery mode — create an account at the end to save everything.",
    signup_to_save: "Create an account to save",
    listen: "Listen",
    stop: "Stop",
    print_pdf: "Print / PDF",
    forgot_password: "Forgot password?",
    forgot_title: "Reset your password",
    forgot_intro:
      "Enter your email. If an account exists, you'll get a link to choose a new password.",
    forgot_sent:
      "If an account exists for this email, a reset link has been sent.",
    send_link: "Send link",
    reset_title: "Choose a new password",
    new_password: "New password",
    reset_cta: "Save the new password",
    reset_ok: "Password updated! You can log in now.",
    monthly_reminder: "Monthly reminder",
    monthly_reminder_desc:
      "Get a gentle browser reminder to save each month.",
    enable_reminder: "Enable reminders",
    disable_reminder: "Disable",
    reminder_enabled: "Reminders enabled",
    reminder_permission_denied:
      "Your browser blocks notifications. Please allow them in settings.",
    voice_settings: "Voice",
    voice_choose: "Choose voice",
    voice_speed: "Speed",
    voice_slow: "Slow",
    voice_normal: "Normal",
    voice_fast: "Fast",
    voice_default: "Default voice",
    voice_test: "Test voice",
    voice_none_available:
      "No voice installed in your browser for this language.",
    voice_star_hint:
      "⭐ = recommended voices, the most natural to listen to.",
    badges: "Your badges",
    checkin_title: "I saved money this month",
    checkin_desc:
      "Tap here whenever you've set aside your savings this month. You'll earn a badge at each milestone!",
    checkin_btn: "Validate this month",
    checkin_done: "Bravo! You've validated this month.",
    checkin_this_month: "Current month",
    badge_first_month: "First month",
    badge_first_month_desc: "Your very first saved month. Bravo!",
    badge_three_months: "Three months",
    badge_three_months_desc: "Three months of saving. You're finding your rhythm!",
    badge_six_months: "Six months",
    badge_six_months_desc: "Six months. You're a real regular saver now.",
    badge_one_year: "One full year",
    badge_one_year_desc: "A full year of saving. Amazing!",
    badge_streak_3: "3 months in a row",
    badge_streak_3_desc: "Three consecutive months without missing. Well done!",
    badge_temporal_1_month: "One month on Sereno",
    badge_temporal_1_month_desc: "It's been a month since you joined Sereno.",
    badge_temporal_6_months: "6 months on Sereno",
    badge_temporal_6_months_desc: "6 months loyal to Sereno.",
    badge_temporal_1_year: "1 year on Sereno",
    badge_temporal_1_year_desc: "One year on Sereno, what a journey!",
    badge_tutorial_done: "Tutorial done",
    badge_tutorial_done_desc: "You completed the full journey. Nice work!",
    badge_expert_en_herbe: "Budding expert",
    badge_expert_en_herbe_desc: "You passed the financial quiz. You now know more than 80% of people!",
    badge_locked: "Badge to unlock",
    badge_unlocked: "New badge unlocked!",
    share_family: "Send to a loved one",
    share_title: "Share this recommendation",
    share_intro:
      "Share this plan with someone you trust: a child, a friend, an advisor.",
    share_email_tab: "By email",
    share_whatsapp_tab: "By WhatsApp",
    share_link_tab: "Copy link",
    share_recipient_email: "Recipient email",
    share_message_label: "Short message (optional)",
    share_message_placeholder:
      "Hi, I'm using Sereno to start saving. Here's the plan. What do you think?",
    share_send_email: "Send by email",
    share_open_whatsapp: "Open WhatsApp",
    share_copy_link: "Copy link",
    share_link_copied: "Link copied!",
    share_email_sent: "Email sent!",
    share_link_valid: "Link valid for 30 days",
    shared_from: "Shared by",
    shared_wants_to_share: "wants to share with you",
    shared_join: "Start on Sereno too",
    shared_expired: "This share has expired or does not exist.",
    open_title: "How to open it in practice?",
    open_where: "Where to open",
    open_docs: "What to prepare",
    open_min: "Minimum amount",
    open_time: "How long",
    open_phrase: "What to say to the advisor",
    open_online: "Online",
    open_branch: "In branch",
    open_call: "Call",
    open_visit: "Visit site",
    open_reassurance: "Good to know",
    open_guided_available: "Step-by-step guide available",
    open_start_guided: "Walk me through step by step",
    guided_step: "Step",
    guided_of: "of",
    guided_next: "Continue",
    guided_back: "Back",
    guided_finish: "I'm done",
    guided_close: "Close",
    guided_pause: "Pause",
    guided_help: "I'm lost, help me",
    guided_tips: "Tips",
    guided_warning: "Do not forget",
    guided_help_call: "Call the bank",
    guided_help_share: "Send to a loved one",
    guided_help_pause: "Continue later",
    shield: "Scam shield",
    shield_title: "Let's check together before you send any money",
    shield_intro:
      "Paste the platform name, the ad you saw, or anything you were promised. Sereno flags red words — no judgment.",
    shield_placeholder:
      "e.g. 'I have a trading robot that guarantees 15% a month on crypto, limited seats.'",
    shield_check_btn: "Analyze",
    shield_analyzing: "Analyzing…",
    shield_verdict_danger: "Very strong scam signals",
    shield_verdict_caution: "Warning signals to review",
    shield_verdict_trusted: "Recognized player",
    shield_verdict_unknown: "No obvious signal — stay careful",
    shield_flags_title: "What Sereno spotted",
    shield_reflex_title: "The 24h reflex",
    shield_reflex_text:
      "Before sending a cent, wait 24 hours. No real opportunity disappears in 24h — only scams need you to decide fast.",
    shield_action_stop: "Stop everything, don't pay.",
    shield_action_verify: "Ask an official regulator to confirm (AMF, ACPR, FSMA, FINMA, SADC).",
    shield_action_share: "Send this to someone you trust before deciding.",
    ask_sereno: "Ask Sereno a question",
    ask_sereno_short: "Sereno is listening",
    ask_sereno_placeholder: "Type your question here, in simple words…",
    ask_sereno_intro:
      "Ask anything about money, savings, or an offer you were shown. Sereno answers simply, without judgment, anytime.",
    ask_send: "Send",
    ask_clear: "Clear conversation",
    ask_thinking: "Sereno is thinking…",
    ask_disclaimer:
      "Sereno educates and explains — it does not replace a licensed financial advisor and never recommends a specific product.",
    transparency_title: "Full transparency",
    transparency_text:
      "Sereno has NO commercial ties with the providers listed below. No partnership, no commission, no affiliation. We mention them because they offer this type of product. Always compare before choosing, and feel free to ask your current bank.",
    compare_title: "Compare before choosing",
    compare_intro:
      "Never pick the first option. Look at at least 2 providers and ask yourself these 4 questions:",
    compare_q1: "What are the entry, management and exit fees?",
    compare_q2: "Is the interface clear for you?",
    compare_q3: "Is there a real advisor to talk to on the phone?",
    compare_q4: "What does Google say if you type \"reviews [bank name] scam\"?",
    local_bank_title: "What about your neighbourhood bank?",
    local_bank_text:
      "Remember: your own bank probably offers the same product. Fees may be slightly higher, but you get a human advisor, face to face, who knows you. For many, that's worth the difference.",
    local_bank_cta: "Guide: open at your neighbourhood bank",
    mic_start: "Speak",
    mic_stop: "Stop",
    mic_listening: "Sereno is listening…",
    mic_not_supported: "Voice recognition isn't available on this browser. Try Chrome or Safari.",
    voice_reply_on: "Voice reply: on",
    voice_reply_off: "Voice reply: off",
    voice_reply_toggle: "Voice reply",
    decoder: "Photo decoder",
    simulator: "Simulator",
    quiz: "Quiz",
    coach_send_tip: "Get a tip by email",
    coach_tip_sent: "Tip sent by email — check your inbox!",
    coach_tip_failed: "Sending failed, please try again shortly.",
    legal_notice: "Legal notice",
    privacy: "Privacy",
    terms: "Terms",
    contact: "Contact",
    footer_disclaimer:
      "Sereno is an educational tool. The simulations and recommendations shown do not constitute investment advice. You remain the sole decision-maker. Consult a certified professional before any significant investment.",
    affiliate_notice:
      "Transparency: some links to partner banks are affiliate links. If you open an account through these links, Sereno may receive a small commission — at no extra cost to you. We only recommend partners we consider serious, based on fees, reliability and trustworthiness.",
    decoder_title: "A paper you don't understand?",
    decoder_intro:
      "Take a photo. Sereno reads it and explains it in 3 sentences, calling out hidden fees or traps.",
    decoder_choose: "Choose a photo",
    decoder_take: "Take a photo",
    decoder_analyzing: "Sereno is reading your document…",
    decoder_result: "What Sereno understood",
    decoder_new: "Analyze another document",
    decoder_privacy:
      "Your photo is used only for the analysis. It is not stored on our servers.",
    decoder_tip_lighting: "Tip: well-lit photo, no glare, sharp text.",
  },
};

export const t = (lang, key) => dict[lang]?.[key] ?? dict.fr[key] ?? key;
